export const en = {
    avia_class_econom: 'Economy',
    avia_class_business: 'Business',
    avia_class_comfort: 'Comfort',
    avia_class_first: 'First',
};
